<template>
    <modal :show.sync="show" modalClasses="medium-sized-modal event-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Edit Call</h3>
            <ValidationObserver v-slot="{ invalid }" ref="observer">
                <b-form @submit.prevent="submit">
                    <b-row>
                        <input type="text" v-model="model.call_id" hidden>
                        <input type="text" v-model="model.lead_id" hidden>
                        <input type="text" v-model="model.call_status" hidden>
                        <!-- FIELD LEADS -->
                        <b-col cols="12" md="12">
                            <b-form-group label="Lead Name:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallLead'"
                                >
                                <el-select v-model="model.lead_id" filterable placeholder="Select">
                                    <el-option
                                    v-for="lead in leadName"
                                    :key="lead.lead_id"
                                    :label="lead.name"
                                    :value="lead.lead_id">
                                    </el-option>
                                </el-select>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <!-- FIELD CALL TITLE -->
                        <b-col cols="12">
                            <b-form-group label="Subject:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallTitle'"
                                >
                                <b-form-input
                                    name="title2"
                                    v-model="model.title"
                                    input-classes="form-control-alternative new-event--title"
                                    required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <!-- FIELD CALL REMARK CALL -->
                        <b-col cols="12">
                            <b-form-group label="Remark Call:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallRemark'"
                                >
                                    <b-form-textarea
                                    id="textarea"
                                    v-model="model.remark_call"
                                    placeholder="Remark Call"
                                    rows="3"
                                    max-rows="6"
                                    required
                                    ></b-form-textarea>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <!-- FIELD CALL TYPE -->
                        <b-col cols="12">
                            <b-form-group label="Call Type:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallTitle'"
                                >
                                <el-select v-model="model.call_type" filterable placeholder="Select">
                                    <el-option
                                    v-for="(type, index) in callType"
                                    :key="index"
                                    :label="type.label"
                                    :value="type.value">
                                    </el-option>
                                </el-select>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <!-- FIELD CALL DATE -->
                        <b-col cols="12" md="12">
                            <b-form-group label="Date Call:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallType'"
                                >
                                <b-form-datepicker v-model="model.date_call"></b-form-datepicker>   
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <!-- FIELD TIME START -->
                        <b-col cols="12" md="6">
                            <b-form-group label="Time Start:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallStartTime'"
                                >
                                <el-time-picker
                                    v-model="model.start_time"
                                    placeholder="Time Start"
                                    format="HH:mm A"
                                    value-format="HH:mm:ss"
                                    >
                                </el-time-picker>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <!-- FIELD TIME END -->
                        <b-col cols="12" md="6">
                            <b-form-group label="Time End:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallEndTime'"
                                >
                                <el-time-picker
                                    v-model="model.end_time"
                                    placeholder="Time End"
                                    format="HH:mm A"
                                    value-format="HH:mm:ss"
                                    >
                                </el-time-picker>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <!-- FIELD HUB (Assigned To) -->
                        <b-col cols="12" md="12">
                            <b-form-group label="Assigned To:">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'newCallHub'"
                                >
                                <el-select v-model="model.assigned_to" filterable placeholder="Select">
                                    <el-option
                                    v-for="hub in hubName"
                                    :key="hub.hub_id"
                                    :label="hub.hub_name"
                                    :value="hub.hub_id">
                                    </el-option>
                                </el-select>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                            <b-button variant="primary" type="submit" class="w-100" :disabled="invalid">Update</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option, TimePicker } from 'element-ui'
import {

    helperFunctionMixin,
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import { EventBus } from "@/main";
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'

const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();

export default {
    props: {
        update_call: Boolean,
        edit_meeting: Boolean,
        meetingList: Array,
        start: Date,
        end: Date,
        dateInfo: Object,
        callEdited: Object,
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin,
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
        [TimePicker.name]: TimePicker,
    },
    created(){
        this.fetchLead()
        // this.fetchHub()
    },
    computed: {
        show: {
            get() {
                return this.update_call;
            },
            set(newVal) {
                this.$emit('update:update_call', newVal);
            },
        },
    },
    watch: {

        'callEdited'(newVal){
            this.model.hub_id  = newVal.hub_id
            this.model.call_id = newVal.call_id
            this.model.lead_id = Number(newVal.lead_id)
            this.model.title = newVal.subject
            this.model.description = newVal.description
            this.model.date_call = newVal.start_at
            this.model.assigned_to = Number(newVal.hub_id)
            this.model.remark_call = newVal.remark_call,
            this.model.start_time = this.getDataTime(newVal.start_at)
            this.model.end_time = this.getDataTime(newVal.end_at)
            this.model.className = newVal.call_status
            this.model.call_type = newVal.call_type
        }

    },
    data() {
        return {
            profileName: [{
                value: 'Mena',
                label: 'Mena'
                }, {
                value: 'Raziq',
                label: 'Raziq'
                }, {
                value: 'Anthony',
                label: 'Anthony'
                }, {
                value: 'Ben Parker',
                label: 'Ben Parker'
                }, {
                value: 'Masdo',
                label: 'Masdo'
            }],
            durationOptions: [{
                value: '30 mins',
                label: '30 mins'
                }, {
                value: '40 mins',
                label: '40 mins'
                }, {
                value: '60 mins',
                label: '60 mins'
                }, {
                value: '90 mins',
                label: '90 mins'
                }, {
                value: '120 mins',
                label: '120 mins'
            }],
            typeOptions: [
                { text: 'Offline', value: 'offline' },
                { text: 'Online', value: 'online' },
            ],
            eventColors: [
                {
                value:"1",
                label:"event-default",
                status:"Scheduled"
                },
                {
                value:"2",
                    label:"event-green",
                    status:"Completed"
                },
                {
                value:"3",
                    label:"event-orange",
                    status:"Postponed"
                },
                {
                value:"4",
                    label:"event-red",
                    status:"Canceled"
                },
            ],
            leadName:[],
            hubName:[],
            minimumTime: "00:00",
            testtry: "",
            model: {
                title: "New event",
                className: "bg-default",
                description:
                "Nullam id dolor id nibh ultricies vehicula ut id elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
                assigned_to: "",
                start_time: "",
                end_time: "",
                lead_id:"",
                call_status:"",
                remark_call:"",
                date_call:"",
                call_type:""
            },
            callType: [{
                value: 'Outbound',
                label: 'Outbound'
                }, {
                value: 'Inbound',
                label: 'Inbound'
            }],
        }
    },
    methods: {
        updateStartValue(event) {
            this.startValue = event
        },
        updateEndValue(event) {
            this.endValue = event
        },
        submit(){

            const form = {
                'call_id': this.model.call_id,
                'lead_id': this.model.lead_id,
                'hub_id': this.model.assigned_to,
                'subject': this.model.title,
                'remark_call': this.model.remark_call,
                'call_status': this.model.className,
                'date_call': this.model.date_call,
                'time_start': this.model.start_time,
                'time_end': this.model.end_time,
                'remark_meeting': this.model.remark_meeting,
                'call_type': this.model.call_type,
                'reminder': '5',
            }

            axios.put(services.lead + 'call/' + this.model.call_id , form, { headers: getHeader() })
                .then(res => {
                    this.notifySuccess('<b>Status: '+res.data.message+'</b> - Successfully Updated.')
                    this.show = false
                    this.$emit('getCall')
                    // this.getAllMeeting()
                })
                .catch(e => {
                    this.errorFunction(e)
                })
        },
        fetchLead(){
            axios.get(services.lead + 'leads', {headers: getHeader()})
                .then(res => {
                    this.leadName = res.data.data.data
                    this.$emit('listLead',res.data.data.data)
                })
                .catch(e => {
                    this.isTableLoading = false
                    this.errorFunction(e)
                })
            },
        fetchHub(){
            axios.get(services.hub + 'hubs', {headers: getHeader()})
                .then(res => {
                    this.hubName = res.data.data
                })
                .catch(e => {
                    this.isTableLoading = false
                    this.errorFunction(e)
                })
        },
        getDataDate(data){
            const newDate = new Date(data);
            const year = newDate.getFullYear();
            const month = (newDate.getMonth() + 1).toString().padStart(2, '0');
            const day = newDate.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        getDataTime(data){
            const dataDateTime = new Date(data)
            const hrs = dataDateTime.getHours().toString().padStart(2,'0');
            const mins = dataDateTime.getMinutes().toString().padStart(2,'0');
            const secs = dataDateTime.getSeconds().toString().padStart(2,'0');
            return `${hrs}:${mins}:${secs}`
        }
    }
}
</script>